import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { useAppSelector } from '@redux/hooks';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import classNames from 'classnames';
import React, { type FC } from 'react';
import AnalyticsConstants from '../../../../../../../../../constants/analytics';
import VendorAnalytics from '../../../../../../../../decorators/vendorAnalytics';
import Styles from './MediaCTA.scss';
import { ButtonRole, RoundUpOrientation } from './constants';

export interface MediaCTAProps {
	mediaItems: Vendor.IndexedMedia[];
	event: string;
	role: ButtonRole;
	round?: RoundUpOrientation;
	singleButton?: boolean;
	action?: string;
	sourceContent: string;
	isBlockIcon?: boolean;
	onClick?: (index: number) => void;
}
export const MediaCTA: FC<MediaCTAProps> = (props: MediaCTAProps) => {
	const {
		onClick,
		mediaItems,
		singleButton,
		event,
		role,
		round,
		sourceContent,
		action,
		isBlockIcon,
	} = props;

	const vendor = useAppSelector(
		(state) => state.vendor.vendor as Vendor.Decorated,
	);
	const { track } = useAnalyticsContext();

	const trackClick = () => {
		const vendorAnalytics = new VendorAnalytics(vendor);
		const sourcePage =
			vendor.purchaseStatus === 'PAID'
				? AnalyticsConstants.PAID_STOREFRONT
				: AnalyticsConstants.UNPAID_STOREFRONT;
		track({
			event,
			properties: {
				action: action ? action : AnalyticsConstants.CLICK_MOSAIC,
				sourcePage,
				sourceContent: sourceContent
					? sourceContent
					: AnalyticsConstants.MOSAIC_CTA,
				...vendorAnalytics.baseEventProps(),
			},
		});
	};

	const onClickThru = () => {
		trackClick();
	};

	const handleOnClick = () => {
		if (onClick) {
			onClick(mediaItems[0].index);
			trackClick();
		} else {
			onClickThru();
		}
	};

	const buttonText = `${mediaItems.length} ${
		role === ButtonRole.Video ? 'Video' : 'Virtual Tour'
	}${mediaItems.length > 1 ? 's' : ''}`;

	const iconName = role === ButtonRole.Video ? 'play' : '360-degrees';

	const getRoundStyle = () => {
		if (singleButton) {
			return classNames(Styles.leftRoundCorner, Styles.rightRoundCorner);
		}

		if (round === RoundUpOrientation.Left) {
			return Styles.leftRoundCorner;
		}

		return Styles.rightRoundCorner;
	};

	return (
		<button
			className={classNames(
				Styles.button,
				getRoundStyle(),
				role === ButtonRole.Video && isBlockIcon
					? Styles.hideVideoButtonOnMobile
					: '',
			)}
			type="button"
			name={`MediaCTA-${role}`}
			aria-label={`MediaCTA-${role}`}
			onClick={handleOnClick}
		>
			<Icon
				className={classNames(
					isBlockIcon ? Styles.galleryCtasTextBlock : Styles.galleryCtasText,
				)}
				name={iconName}
				aria-label={iconName === 'play' ? 'Video' : 'Virtual tour'}
				size="md"
			/>
			<TextBody
				size="sm"
				color="white"
				bold
				className={classNames(
					Styles.galleryCtasText,
					Styles.galleryCtaLabel,
					Styles.textSpacing,
				)}
			>
				{buttonText}
			</TextBody>
		</button>
	);
};
